export default {
	edit: '編集',
	delete: '削除',
	enable: 'このシナリオで有効にする',
	disable: 'このシナリオで無効にする',
	next_step: '次へ',
	skip: 'スキップ',
	finish_review: '確認を完了',
	skip_review: '確認をスキップ',
	view: '詳細を表示',
	close: '閉じる',
	cancel: 'キャンセル',
	send: '送信',
	clone: '複製',
	open: '開く',
	sign_out: 'サインアウト',
	search: '検索',
	save: '保存',
	sort_by_name: '名前で並べ替え（A→Z）',
	sort_by_importance: '重要度で並べ替え（高→低）',
	filter_positive: 'ポジティブなステークホルダーをフィルター',
	filter_negative: 'ネガティブなステークホルダーをフィルター',
	export: {
		excel: 'Excelファイルとしてエクスポート',
		image: 'ビジュアルを画像としてエクスポート'
	},
	click_to_select: 'クリックして選択',
	click_to_drag: 'ドラッグ＆ドロップで移動',
	confirm_drop: {
		message_baseline:
			'ベースラインを更新しようとしています。変更を確定しますか？',
		message_scenario:
			'シナリオ「{{scenarioName}}」を更新しようとしています。変更を確定しますか？',
		likelihood: '発生可能性',
		impact: '影響',
		before: '変更前',
		after: '変更後'
	}
};
